module.exports = __webpack_public_path__ + "media/bundles/TriipApp/assets/images/step-2-d67df70c3ee305cc0d6b85d521b2d7b2.png";